// Mongo ObjectIds encode their creation time in the first 4 bytes, so we can
// derive a creation timestamp for resources (like folders) that don't store
// their own createdAt field, without any backfill/migration.
export const objectIdTimestamp = (id: string): number => {
    if (!id || id.length < 8) return 0;
    return parseInt(id.substring(0, 8), 16) * 1000;
};
